import type { StagiaireDTO } from '@/features/api/extranet/dto/shared'

export type MaitreApprentissageDTO = StagiaireDTO & {
  email: string | null
  nomNaissance: string | null
  emploiOccupe: string | null
  diplomeOuTitreLePlusEleveObtenu: string | null
  niveauDiplomeOuTitreLePlusEleveObtenu: string | null
}

export const EMPTY_MAITRE_APPRENTIS: MaitreApprentissageDTO = {
  dateNaissance: null,
  diplomeOuTitreLePlusEleveObtenu: null,
  email: null,
  emploiOccupe: null,
  niveauDiplomeOuTitreLePlusEleveObtenu: null,
  nom: null,
  nomNaissance: null,
  prenom: null,
  sexe: null,
} as const

